import useAPI from '@/hooks/useAPI';
import UserChallengeRepository from '@/repositories/UserChallengeRepository';

export const useUserChallengeImageLink = ({
  id,
  enabled = false
}: {
  id: number;
  enabled?: boolean;
}) => {
  const userChallengeRepository = UserChallengeRepository();

  return useAPI({
    queryKey: ['getUserChallengeImageLink', id],
    queryFn: async () => {
      return await userChallengeRepository.getUserChallengeImageLink({ id });
    },
    enabled
  });
};

export default {};
